<template>
    <div ref="component" :class="[buttonClass]" class="select-none overflow-visible">
        <!-- this had the class overflow-hidden -->
        <div :class="[buttonCSS, desktopOpen ? 'lg:pointer-events-none' : '']" class="flex" :disabled="disabled">
            <button
                :disabled="disabled"
                class="hover:cursor-pointer disabled:cursor-default w-full foucs:outline-0 outline-0 flex items-center"
                type="button"
                @click.stop="!preventButtonClick ? (isSelectMenu ? (!open ? toggle() : null) : toggle()) : null"
            >
                <slot :open="open" :toggle="toggle" name="button" />
            </button>

            <div v-if="$slots['buttons-right'] != undefined" :class="buttonsRightClass" class="grid gap-2 grid-flow-col auto-cols-min">
                <slot name="buttons-right" :open="open" />
            </div>
        </div>
        <!-- desktopOpen && open ? "lg:overflow-visible" : ""  -->
        <!-- <Teleport to="body"> -->
        <TransitionHeight
            ref="menu"
            :class="[lMenuClass, menuClass, menuPush ? '!relative !top-0 !bottom-0' : '']"
            :style="[menuStyle, hasShadow ? 'box-shadow: 0px '+(activeDirection == 'bottom' ? '-10px' : '10px')+' 20px 0px rgb(0 0 0 / 20%);' : '']"
            :transitionDisabledWhenOpen="transitionDisabledWhenOpen"
            :visable="open"
            class="absolute z-[2000] size-max"
            @click="detectClose"
            :duration="menuSpeed"
        >
            <slot :activeDirection="activeDirection" :open="open" name="menu" />
        </TransitionHeight>

        <!-- </Teleport> -->
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import { onClickOutside } from '@vueuse/core'

export default {
    props: {
        allowClickOutSide: { type: Boolean, default: true },
        ignoreParent: { type: Boolean, default: false },
        buttonCSS: {
            type: [Array, Object, String],
            default: '',
        },
        menuClass: {
            type: [Array, Object, String],
            default: '',
        },
        forceSide: {
            type: [String, Boolean],
            default: false,
        },
        forceDirection: {
            type: [String, Boolean],
            default: false,
        },
        menuSpace: { type: Number, default: 0 }, // was 8
        disabled: { type: Boolean, deafult: false },
        desktopOpen: { type: Boolean, deafult: false },
        transitionDisabledWhenOpen: {
            type: Boolean,
            default: false,
        },
        emitName: {
            type: [String, Boolean],
            default: false,
        },
        isSelectMenu: { type: Boolean, deafult: false },
        menuPush: { type: Boolean, deafult: false },
        buttonsRightClass: {
            type: [Array, Object, String],
            default: '',
        },
        preventButtonClick: {
            type: Boolean,
            default: false,
        },
        hasShadow: { type: Boolean, default: true },
        loadOpen: { type: Boolean, default: false },
        scrollToBottomFirst: { type: Boolean, default: false },
    },

    data() {
        return {
            open: this.desktopOpen && window.innerWidth >= 1024 ? true : false,
            buttonClass: null,
            menuStyle: null,
            lMenuClass: null,
            canBeClosed: false,
            activeDirection: 'top',
            menuSpeed: 35,
        }
    },

    mounted() {
        onClickOutside(this.$refs.component, (event) => {
            this.clickedOutSideOfMenu()
        })

        window.addEventListener('resize', this.setMenuStyle)

        if (this.loadOpen) {
            this.menuSpeed = 0
            this.open = true
            setTimeout(() => {
                this.menuSpeed = 35
            }, 100)
        }

        if (this.emitName !== false) {
            this.$event.$on(this.emitName, (action) => {
                setTimeout(() => {
                    if (action.toggle) {
                        this.toggle()
                    }
                })
            })
        }
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.setMenuStyle)
    },

    methods: {
        toggle() {
            // if (!this.canBeClosed && this.open) {
            //     return
            // }

            if (!this.open) {
                this.setMenuStyle()
                
                if (this.scrollToBottomFirst) {
                    const scrollInterval = setInterval(() => {
                        window.scrollTo({
                            top: document.body.scrollHeight,
                            behavior: 'instant'
                        });
                    }, 10);

                    setTimeout(() => {
                        clearInterval(scrollInterval);
                    }, 700);
                }
            }

            this.open = !this.open
            this.$emit('dropdown', this.open)

            setTimeout(() => {
                this.canBeClosed = this.open
            }, 300)
        },

        clickedOutSideOfMenu(e) {
            if (this.canBeClosed === false) {
                return
            }

            if (!this.allowClickOutSide || !this.open || (e != null && e.target.dataset.dontClose !== undefined)) {
                return
            }

            this.toggle()

            // this.$nextTick(() => {
            // 	this.toggle()
            // 	setTimeout(() => {
            // 		this.$emit('closed')
            // 	}, 300)
            // })
        },

        detectClose(e) {
            if (this.$help.getParentUntil(this.$el, e.target) === false) {
                return
            }

            if (e.target.dataset.dontClose !== undefined) {
                return
            }

            if (e.target.dataset.close !== undefined || e.target.parentElement.dataset.close !== undefined) {
                this.clickedOutSideOfMenu()
            }
        },

        setMenuStyle() {
            if (this.$refs.component == undefined || this.$refs.menu == undefined) {
                return
            }

            let btn = this.$refs.component,
                menu = this.$refs.menu.$el,
                htmlElement = document.documentElement,
                bodyElement = document.body

            let pageHeight =
                Math.max(
                    htmlElement.clientHeight,
                    htmlElement.scrollHeight,
                    htmlElement.offsetHeight,
                    bodyElement.scrollHeight,
                    bodyElement.offsetHeight,
                ) - 100

            let activeSide = btn.offsetParent != null && btn.offsetLeft + menu.clientWidth > btn.offsetParent.clientWidth ? 'right' : 'left'

            if (this.forceSide !== false) {
                activeSide = this.forceSide
            }

            this.activeDirection = this.$help.getTotalOffsetParent(btn) > pageHeight ? 'bottom' : 'top'

            if (this.forceDirection !== false) {
                this.activeDirection = this.forceDirection
            }

            let parentIsPositionAbsolute =
                btn.offsetParent != null && window.getComputedStyle(btn.offsetParent).getPropertyValue('position') != 'relative'

            if (this.ignoreParent) {
                parentIsPositionAbsolute = false
            }

            // this.buttonClass = parentIsPositionAbsolute ? 'relative' : 'lg:relative'
            // had to remove the above becasue of the grid tabs on mobile
            this.buttonClass = 'relative'

            this.menuStyle = {
                [this.activeDirection]: ((btn.clientHeight + this.menuSpace) + (this.activeDirection == 'bottom' ? 0 : 0)) + 'px',
            }

            // (!parentIsPositionAbsolute ? ' left' : '')
            // (!parentIsPositionAbsolute ? ' right-0' : '')

            this.lMenuClass =
                activeSide == 'right'
                    ? 'right-0 lg:left-auto' + (!parentIsPositionAbsolute ? ' ' : '')
                    : 'left-0 lg:right-auto' + (!parentIsPositionAbsolute ? ' ' : '')
        },
    },

    directives: {
        clickOutside: vClickOutside.directive,
    },
}
</script>
